const styles = theme => ({
  root: {
    width: '100%',
    maxWidth: 1280,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: 24,
    marginBottom: 20,
  },
  title: {
    color: '#0B1D2E',
    textAlign: 'center',
    fontFamily: 'Inter',
    fontSize: '40px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '150%',
    letterSpacing: '-0.8px',
    marginBottom: 32,
    '@media (max-width: 600px)': {
      fontSize: '28px',
      lineHeight: '36px',
    },
  },
  toggleContainer: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#F4F6F8',
    borderRadius: 24,
    padding: 4,
    gap: 0,
  },
  toggleOption: {
    padding: '8px 24px',
    borderRadius: 20,
    fontSize: '14px',
    fontFamily: 'Inter',
    fontWeight: 500,
    color: '#637381',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    userSelect: 'none',
  },
  toggleActive: {
    backgroundColor: '#002E47',
    color: '#fff',
    fontWeight: 600,
  },
})

export default styles
